import React, { useCallback, useContext } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import SelfDevelopmentToolPage from './SelfDevelopmentToolPage';
import { SidebarContext } from '../../../../context/SidebarContext';
import { useCompanySectionFilter } from '../../../../component/B2B/CompanySectionLayout';
import { fetchCompanySelfDevelopmentTool } from './companySelfDevelopmentApi';

/**
 * Company Self Development → one tool's page.
 *
 * All five tool routes render this component; the tool is the last segment of
 * the path, which is also the tool key the backend expects. Five near-identical
 * route wrappers would have said nothing the URL doesn't already say.
 */
const TOOL_TITLES = {
  gratitude: 'Gratitude',
  cleanse: 'Cleanse',
  journal: 'Journal',
  goals: 'Goals',
  affirmations: 'Affirmations'
};

const CSelfDevelopmentTool = () => {
  const location = useLocation();
  const { isB2BFansMode } = useContext(SidebarContext);
  const { department } = useCompanySectionFilter();

  const tool = location.pathname.split('/').filter(Boolean).pop();

  const fetcher = useCallback(
    () => fetchCompanySelfDevelopmentTool(tool, department),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [tool, isB2BFansMode, department]
  );

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{TOOL_TITLES[tool] || 'Self Development'} | Shoorah</title>
      </Helmet>
      <SelfDevelopmentToolPage
        tool={tool}
        fetcher={fetcher}
        populationLabel={isB2BFansMode ? 'members' : 'employees'}
      />
    </div>
  );
};

export default CSelfDevelopmentTool;
